module.exports = __webpack_public_path__ + "media/images/CWDA_logo-0fce7bb9590dbf87e08021874d4b5947.png";